// extracted by mini-css-extract-plugin
export default {"body":"JmKFui3qgTn1pGySPbED"};